import script from "./quickBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./quickBtn.vue?vue&type=script&setup=true&lang=js"

import "./quickBtn.vue?vue&type=style&index=0&id=5def9b43&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5def9b43"]])

export default __exports__